import { Link } from "react-router-dom";

export function AliciaNavLinks({ t, checkIfActive, navbarTextColor, user }) {
  return (
    <>
      <Link
        to={"/products"}
        className={`grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none ${
          checkIfActive("/products") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/products") ? { color: navbarTextColor } : undefined
        }
        data-testid="allProductsNav"
      >
        {t("allProducts")}
      </Link>
      {["hybrid", "buyer"].includes(user?.userRole) && (
        <Link
          to="/my-requests"
          className={`grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none ${
            checkIfActive("/my-requests") ? "text-amber-500" : ""
          }`}
          style={
            !checkIfActive("/my-requests")
              ? { color: navbarTextColor }
              : undefined
          }
        >
          {t("myRequests")}
        </Link>
      )}
      <Link
        to={"/asset-management"}
        className={`grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none ${
          checkIfActive("/asset-management") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/asset-management")
            ? { color: navbarTextColor }
            : undefined
        }
        data-testid="myProductsNav"
      >
        {t("assetManagement")}
      </Link>
    </>
  );
}
